<template>
  <div class="z-footer">
    <span v-if="deptId!=1011&&deptId!=1016">
    <div class="z_div">
      <p>
        Copyright @ 宁波产权交易中心版权所有<br />
        主办单位：宁波产权交易中心有限公司
        <!-- <span style="margin-left:8px">87198137</span> -->
        <br />
        <!-- 通讯地址：鄞州区金融硅谷7号楼14号三楼阳光采购服务平台<br /> -->
        阳光采购平台业务进场咨询：0574-88029656(王)<br />
        <!-- 技术支持电话：18968299314 0574-87187195(胡)<br /> -->
        阳光采购平台政策咨询：0574-87198137(滕)<br />
        阳光采购平台专家管理咨询：0574-88029925<br />
        保证金收退及发票管理咨询电话：0574-88307965(洪)<br />
      </p>
      <p>
        
        <a href="#">浙ICP备11064635号</a><br />
        通讯地址：{{address}}<br />
        技术问题咨询QQ群：627476062 425851404<br />
        电子投标及技术支持电话：0574-26877268 13396609883<br />
        阳光采购平台信息技术部：0574-87187195<br />
        天谷CA：400-087-8198 转6 天威诚信：0574-87329560<br />
        <!-- 0574-87187183(刘) -->
      </p>
      <p>
        <img
          @click="goTo"
          style="margin-top: 55px; cursor: pointer"
          src="../../assets/footer2.png"
        />
      </p>
      <p style="text-align: center;">
        <img
          style="margin-top: 5px; cursor: pointer"
          src="../../assets/WXQR.png"
        /><br/>
        关注公众号
      </p>
    </div>
    <div style="text-align: center;margin-right: 350px;margin-top: -27px;">
      <span style="color: red;font-weight: bolder;">电话咨询时间：工作日8:30-12:00 13:30-17:00</span>
    </div>
    </span>
    <span v-if="deptId==1016||deptId==1011">
      <div class="z_div">
        <p style="margin-top: 25px;">
          Copyright @ 宁波产权交易中心版权所有<br />
          主办单位：宁波产权交易中心有限公司
          <!-- <span style="margin-left:8px">87198137</span> -->
          <br />
          <!-- 通讯地址：鄞州区金融硅谷7号楼14号三楼阳光采购服务平台<br /> -->
           <span v-if="deptId==1016">
            镇海分平台进场咨询：0574-88889986(王)<br />
           </span>
           <span v-if="deptId==1011">
            北仑分平台进场咨询：0574-86785937<br />
           </span>
          阳光采购平台信息技术部：0574-87187195<br />
        </p>
        <p style="margin-top: 25px;">
          
          <a href="#">浙ICP备11064635号</a><br />
          技术问题咨询QQ群：627476062 425851404<br />
          电子投标及技术支持电话：0574-26877268 13396609883<br />
          天谷CA：400-087-8198 转6 天威诚信：0574-87329560<br />
          <!-- 0574-87187183(刘) -->
        </p>
        <p>
          <img
            @click="goTo"
            style="margin-top: 55px; cursor: pointer"
            src="../../assets/footer2.png"
          />
        </p>
        <p style="text-align: center;">
          <img
            style="margin-top: 5px; cursor: pointer"
            src="../../assets/WXQR.png"
          /><br/>
          关注公众号
        </p>
      </div>
    </span>
  </div>
</template>
<script>
import {
  GetDeptInfo
} from "@/api/Home";
export default {
  data() {
    return {
      address: "",
    };
  },
  components: {},
  methods: {
    goTo() {
      // window.open(
      //   "http://www.bcpcn.com/product/pjia/da/BCP75045882F569822.html",
      //   "_blank"
      // );
      window.open(
        "http://www.bcpcn.com/product/pjia/da/BCP76877536F323522.html",
        "_blank"
      );
    },
    GetDeptInfo() {
      let param = {};
      param.DeptId = this.deptId;
      GetDeptInfo(param).then((res) => {
        this.address = res.data.deptInfo.item.deptAddress;
      })
    }
  },
  mounted(){
    const query = this.$route.query;
    this.deptId = query.deptId; 
    this.GetDeptInfo();
  }
};
</script>
<style lang="less">
// .z-footer{
//    color: rgba(255, 255, 255, .65);
//    background: #333333;
//    padding: 24px 0;
//    .z_div{
//       width: 1240px;
//       padding: 0 16px;
//       margin: auto;
//       display: flex;
//       justify-content: space-between;
//       p{
//          line-height: 30px;
//          display: inline;
//          margin-bottom: 0;
//          a{
//             color: rgba(255, 255, 255, .65);
//          }
//          a:hover{
//             color: #f5222d;
//          }
//       }
//    }
// }
</style>